
import { defineComponent } from 'vue';

//import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";
import { apiEndpoint } from "@/mixin/apiEndpoint";
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import { VueCookieNext } from "vue-cookie-next";
import axios from 'axios';
import { ElNotification } from 'element-plus';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  mixins: [apiEndpoint],
  name: 'new-on-going-course-summary-report',
  components: {
    axios,
    Datatable,
    Multiselect,
  },
  data() {
    return {
      batch: {
        tranche_id: [] as any,
        start_date: '',
        end_date: '',
      },
      api_url: '',
      total: [],
      data: [],
      optionsTranche: [] as any,
      tranches_info: [],
       TrancheInfos: [] as any,
      componentKey: 0,
      loading: false,
      load: false,
      courseInfoData: false,
      showCourseNotice: false,
      showtrainingProviderNotice: false,
    };
  },
  async created() {
    this.api_url = this.VUE_APP_API_URL;
    await this.getTranches();
  },
  methods: {
    async downloadPdf() {
      ElNotification({
        dangerouslyUseHTMLString: true,
        message:
          '<i class="fa fa-download" aria-hidden="true"></i> <b>Downloading...</b>',
          duration: 0,
      });
      let formData = new FormData();

      formData.set('tranche_id', this.batch.tranche_id);
      formData.set('start_date', this.batch.start_date);
      formData.set('end_date', this.batch.end_date);
      await ApiService.post('report/ethnic-minority_pdf', formData)
        .then((response) => {
          Swal.fire({
            title: 'Download Successfull!',
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'View/Download PDF',
          }).then((result) => {
            if (result.isConfirmed) {
              // redirect to new tab

              let path = `${this.VUE_APP_API_URL}/${response.data}`;

              window.open(path, '_blank');
            }
          });
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async printPdf() {
      let formData = new FormData();

      formData.set('tranche_id', this.batch.tranche_id);
      formData.set('start_date', this.batch.start_date);
      formData.set('end_date', this.batch.end_date);
      axios
        .post(`${this.VUE_APP_API_URL}/api/report/ethnic-minority_print`, formData)
        .then(response => {
          document.write(response.data);
          window.print();
          location.reload();
          //open the new window and write your HTML to it         
        })

    },
    async exportTrainee() {
      ElNotification({
        dangerouslyUseHTMLString: true,
        message:
          '<i class="fa fa-download" aria-hidden="true"></i> <b>Downloading...</b>',
          duration: 0,
      });
      let formData = new FormData();

      formData.set('tranche_id', this.batch.tranche_id);
      formData.set('start_date', this.batch.start_date);
      formData.set('end_date', this.batch.end_date);

      axios
        .post(
          `${this.VUE_APP_API_URL}/api/report/ethnic-minority_export`,
          formData,
          {
            responseType: 'blob',
          }
        )
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: 'application/vnd.ms-excel',
            })
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ethnic-minority_export.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((response) => {
          console.log(response);
        });
    },
    async formSubmit() {
      //form submit
    },
    async getTranches() {
     this.load = true;
      await ApiService.get(this.VUE_APP_TRANCHE_LIST_API)
        .then((response) => {
          this.TrancheInfos = response.data.data;
          this.TrancheInfos.forEach((item, index) => {
            let obj = {
              value: item.id,
              label: item.label,
            };
            this.optionsTranche.push(obj);
          });
        })
        .catch(({ response }) => {
         this.load = false;
          console.log(response);
        });
    },

    trainingProviderNotice() {
      this.loading = true;
      ApiService.get(
        "report/ethnic-minority?tranche_id=" +
        this.batch.tranche_id +
        "&start_date=" +
        this.batch.start_date +
        "&end_date=" +
        this.batch.end_date
      )
        .then((response) => {
          this.loading = false;
          this.data = response.data.data.ethnic_data;
          this.total = response.data.data.total;
          this.showCourseNotice = true;
          console.log(response);
        })
        .catch((response) => {
          this.loading = false;
          console.log(response);
        });
    },
  },
  setup() { },
});
